import { useStyles } from "@b2bportal/core-themes";
import {
  type CoreTravelerComponent,
  CORE_TRAVELER_NAME,
} from "~core-traveler/types";

export const useTravelerStyles = (
  componentName: keyof typeof CoreTravelerComponent,
  defaultStyles?: object
) => {
  return useStyles(CORE_TRAVELER_NAME, componentName, defaultStyles);
};
